export * from './search/YadoSearchMethods';
export * from './search/SnowItemSearchMethods';
export * from './yadoHelper';
export * from './snowItemHelper';

export const wait = (duration: number = 700) => {
  return new Promise<void>((resolve) => {
    setTimeout(() => { resolve(); }, duration);
  });
}

export const scrollTo = (scrollElement: HTMLElement, to: number, duration: number) => {
  if (duration <= 0) { return };
  const difference: number = to - scrollElement.scrollTop;
  const perTick: number = difference / duration * 10;
  window.setTimeout(() => {
    scrollElement.scrollTop = scrollElement.scrollTop + perTick;
    if (scrollElement.scrollTop === to) { return };
    scrollTo(scrollElement, to, duration - 10);
  }, 10);
}
